import { updatelayoutAdsData } from 'helpers/ads/revenueRedux';
import { getSiteDomain, randomNum } from '../../utils/common';
import makeRequest from '../../utils/makeRequest';
import reducerRegistry from '../../reduxUtils/reducerRegistry';
import { TOI_LIVE_DOMAIN } from '../../constants';
import {
  filteredDataForExitPoll,
  getExitPollDataForStates,
  getSortedViewDataForSingleState,
  getSortedViewDataForStates,
} from './utils/computation';

const reducerName = 'electionV2';
const createActionName = name => `toi/${reducerName}/${name}`;

const ELECTION_CONTENT_FEED_PATH =
  '/homepage_election_feed/msid-102278998,feedtype-sjson.cms';

export const RECEIVE_ELECTION_DATA = createActionName('RECEIVE_ELECTION_DATA');
export const RECEIVE_ELECTION_RESULT_DATA = createActionName(
  'RECEIVE_ELECTION_RESULT_DATA',
);
export const HANDLE_ELECTION_DATA_ERROR = createActionName(
  'HANDLE_ELECTION_DATA_ERROR',
);

export const DATA_LOADING = createActionName('DATA_LOADING');

export const DATA_LOADED = createActionName('DATA_LOADED');

function receiveElectionData(data) {
  return {
    type: RECEIVE_ELECTION_DATA,
    payload: data,
  };
}

function receiveElectionResultData(data) {
  return {
    type: RECEIVE_ELECTION_RESULT_DATA,
    payload: data,
  };
}

function handleElectionDataError() {
  return {
    type: HANDLE_ELECTION_DATA_ERROR,
    payload: {},
  };
}

export function dataLoading() {
  return {
    type: DATA_LOADING,
    payload: {},
  };
}

export function dataLoaded() {
  return {
    type: DATA_LOADED,
    payload: {},
  };
}

// function fetchDataFromUrl(url) {
//   return makeRequest.get(url, 'skipfeedengine');
// }

async function fetchElectionData(data = null, feedUrl, web) {
  const requestParams = {
    params: {},
  };
  let response = data ? { data } : null;
  if (!response) {
    const feedPath = web ? `${feedUrl}?pfm=web` : feedUrl;
    const url = feedPath;
    response = await makeRequest.get(url, requestParams, 'skipfeedengine');
  }
  if (
    response?.data?.result?.scores?.url &&
    response?.data?.result?.starcandidate?.url
  ) {
    const scores = await makeRequest.get(
      `${response.data.result.scores.url}?t=${randomNum()}`,
      requestParams,
      'skipfeedengine',
    );
    const starCandidate = await makeRequest.get(
      `${response.data.result.starcandidate.url}?t=${randomNum()}`,
      requestParams,
      'skipfeedengine',
    );
    response.data.result.starcandidate.data = starCandidate.data;
    response.data.result.scores.data = scores.data;
  } else if (response?.data?.exitpoll?.url) {
    const exitpoll = await makeRequest.get(
      `${response.data.exitpoll.url}?t=${randomNum()}`,
      requestParams,
      'skipfeedengine',
    );
    response.data.exitpoll.data = exitpoll.data;
  }
  return response;
}

async function fetchExitPollData(exitPollResultObject) {
  const requestParams = {
    params: {},
  };
  const exitpoll = await makeRequest.get(
    exitPollResultObject.exitpoll.url,
    requestParams,
    'skipfeedengine',
  );
  exitPollResultObject.exitpoll.data = exitpoll.data;
  return exitPollResultObject;
}

async function fetchResultData(exitPollResultObject) {
  const requestParams = {
    params: {},
  };
  const result = await makeRequest.get(
    `${exitPollResultObject.result.url}?t=${randomNum()}`,
    requestParams,
    'skipfeedengine',
  );
  exitPollResultObject.result.data = result.data;
  return exitPollResultObject;
}

export function loadElectionData(
  data = null,
  url = `${getSiteDomain()}${ELECTION_CONTENT_FEED_PATH}`,
  web = true,
) {
  return dispatch =>
    // dispatch(dataLoading());
    fetchElectionData(data, url, web)
      .then(response => {
        // dispatch(dataLoaded());
        dispatch(receiveElectionData(response.data));
        if (typeof window === 'undefined' && response?.data?.ads) {
          dispatch(updatelayoutAdsData(response.data.ads));
        }
      })
      .catch(error => {
        //dispatch(dataLoaded());
        dispatch(handleElectionDataError(error));
      });
}

export function loadExitPoll(exitPollObject, loader = false) {
  return dispatch => {
    if (loader) {
      dispatch(dataLoading());
    }
    return fetchExitPollData(exitPollObject)
      .then(response => {
        if (loader) {
          dispatch(dataLoaded());
        }
        dispatch(receiveElectionData(response));
      })
      .catch(error => {
        if (loader) {
          dispatch(dataLoaded());
        }
        dispatch(handleElectionDataError(error));
      });
  };
}

export function loadResult(exitPollObject, loader = false) {
  return dispatch => {
    if (loader) {
      dispatch(dataLoading());
    }
    return fetchResultData(exitPollObject)
      .then(response => {
        if (loader) {
          dispatch(dataLoaded());
        }
        dispatch(receiveElectionResultData(response));
      })
      .catch(error => {
        if (loader) {
          dispatch(dataLoaded());
        }
        dispatch(handleElectionDataError(error));
      });
  };
}

export default function reducer(state = {}, action = {}) {
  // console.log(action);
  switch (action.type) {
    case DATA_LOADING: {
      return {
        ...state,
        dataLoading: true,
      };
    }
    case DATA_LOADED: {
      return {
        ...state,
        dataLoading: false,
      };
    }
    case RECEIVE_ELECTION_DATA: {
      const {
        refreshinterval = 0,
        exitpoll = {},
        displaytext = 'Elections',
        path = TOI_LIVE_DOMAIN,
        shareTitle,
        hideexitheading = 0,
        datasource = '',
        keywords = {},
        breakingnews = [],
        states = [],
        liveblog = {},
        result = {},
        inpageminitv,
        threeDViewBanner = {},
      } = action.payload;
      if (exitpoll?.url) {
        const exitPollSourceData = filteredDataForExitPoll(
          exitpoll?.data,
          states,
        );
        const exitPollStateData = getExitPollDataForStates(
          exitPollSourceData,
          states,
        );
        return {
          ...state,
          refreshinterval,
          electionData: exitpoll?.data ? exitpoll?.data : result?.scores?.data,
          sortedData: exitPollStateData,
          starCandidateData: result?.starcandidate?.data,
          isExitPoll: !!exitpoll?.url,
          exitpoll,
          result,
          displaytext,
          keywords,
          breakingnews,
          states,
          liveblog,
          datasource,
          hideexitheading,
          inpageminitv,
          path,
          shareTitle,
          threeDViewBanner,
        };
      }
      if (result?.scores?.data) {
        const sortedData = getSortedViewDataForStates(
          result?.scores?.data,
          states,
        );
        return {
          ...state,
          refreshinterval,
          electionData: exitpoll?.data ? exitpoll?.data : result?.scores?.data,
          starCandidateData: result?.starcandidate?.data,
          sortedData,
          isExitPoll: !!exitpoll?.url,
          exitpoll,
          result,
          displaytext,
          keywords,
          breakingnews,
          states,
          liveblog,
          datasource,
          hideexitheading,
          inpageminitv,
          path,
          shareTitle,
          threeDViewBanner,
        };
      }
      return { ...state };
    }
    case RECEIVE_ELECTION_RESULT_DATA: {
      const {
        refreshinterval = 0,
        exitpoll = {},
        displaytext = 'Elections',
        path = TOI_LIVE_DOMAIN,
        shareTitle,
        hideexitheading = 0,
        datasource = '',
        keywords = {},
        breakingnews = [],
        states = [],
        liveblog = {},
        result = {},
        common = false,
      } = action.payload;
      let sortedData = null;
      if (common) {
        sortedData = getSortedViewDataForStates(result?.data, states);
      } else {
        sortedData = getSortedViewDataForSingleState(result?.data, states);
      }
      return {
        ...state,
        refreshinterval,
        electionData: result?.data,
        starCandidateData: result?.data,
        sortedData,
        isExitPoll: false,
        exitpoll,
        result,
        displaytext,
        keywords,
        breakingnews,
        states,
        liveblog,
        datasource,
        hideexitheading,
        path,
        shareTitle,
      };
    }
    case HANDLE_ELECTION_DATA_ERROR: {
      return {
        ...state,
        electionData: {},
      };
    }

    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
